import team2021 from "./teams/team-2021.js";
import team2022 from "./teams/team-2022.js";
import team2023 from "./teams/team-2023.js";
import team2024 from "./teams/team-2024.js";
import team2025 from "./teams/team-2025.js";
import team2026 from "./teams/team-2026.js";

const teams = [team2021, team2022, team2023, team2024, team2025, team2026];

export default teams;
